import React from 'react'
import Box from '@material-ui/core/Box'
import FinanceDepositWayGroupToolbar from '../../../components/admin/finance/FinanceDepositWayGroupToolbar'
import FinanceDepositWayGroupTable from '../../../components/admin/finance/FinanceDepositWayGroupTable'
import ScrollablePaper from '../../../components/default/present/ScrollablePaper'
import { SearchToRequestFunc } from '../../../utils/default/ComplexFlowHook'
import { acceptUndefined, pipe, guaranteeBetween } from '../../../utils/default/FormHelper'
import useGDK from '../../../providers/admin/gdk/useGDK'
import { Branch, FinanceDepositWayGroupQuery, PaginationReq } from '@golden/gdk-admin'
import { omitBy, isUndefined } from '@golden/utils'

export type RequestType = PaginationReq & FinanceDepositWayGroupQuery

export const searchToRequest: SearchToRequestFunc<RequestType> = (search) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const is_active = acceptUndefined(
    search.is_active,
    pipe(
      parseInt,
      (value) => guaranteeBetween(value, 0, 2)
    )
  )

  const converted = {
    page: acceptUndefined(
      search.page,
      pipe(
        parseInt,
        (value) => guaranteeBetween(value, 1, Number.MAX_SAFE_INTEGER)
      )
    ) || 1,
    is_active: is_active === undefined ? 1 : is_active,
    method: search.method
  } as RequestType
  return omitBy(converted, isUndefined) as RequestType
}

const FinanceDepositWayGroupPage: React.FC = () => {
  return (
    <Box paddingY={5}>
      <ScrollablePaper marginX={5}>
        <Box padding={4}>
          <FinanceDepositWayGroupToolbar />
        </Box>
        <Box paddingTop={1} paddingBottom={5} paddingX={4}>
          <FinanceDepositWayGroupTable />
        </Box>
      </ScrollablePaper>
    </Box>
  )
}

export default React.memo(FinanceDepositWayGroupPage)
